import React, {
  useEffect,
} from 'react';
import Button from 'pages/Dashboard/components/Button';
import Tooltip from 'core/components/Tooltip';
import useAppVersionCheck from 'versioning/useAppVersionCheck';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';

export default function AppVersionUpdateBanner() {
  const {
    updateAvailable,
    reloadApp,
  } = useAppVersionCheck();

  useEffect(() => {
    document.body.classList.toggle('app-update-active', updateAvailable);
    return () => {
      document.body.classList.remove('app-update-active');
    };
  }, [updateAvailable]);

  return updateAvailable ? (
    <div
      role="alert"
      className="bg-amber-500 border-y border-amber-600 text-slate-900 px-3 py-1 flex items-center justify-center gap-2 z-[9999] sticky top-0 text-sm"
    >
      <div className="flex items-center gap-2">
        <BrowserUpdatedIcon className="!text-slate-900 !w-6 !h-6" />
        <div className="flex items-center gap-0.5">
          <span className="font-semibold">A new version is available.</span>
        </div>
      </div>
      <div className="flex items-center gap-3 !ml-10">
        <Tooltip title="Reload to get the latest version">
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={reloadApp}
            className="!bg-slate-900 !text-white !border !border-slate-900 hover:!bg-slate-800 rounded-lg text-xs !px-3 !py-1.5 !h-7"
          >
            Get latest
          </Button>
        </Tooltip>
      </div>
    </div>
  ) : null;
}
